/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProspectsSearchCondition { 
    pageSize?: number;
    page?: number;
    readonly listSortDirection?: ProspectsSearchCondition.ListSortDirectionEnum;
    sortDirection?: string;
    sortProperty?: string;
    status?: Array<ProspectsSearchCondition.StatusEnum>;
    companyName?: Array<string>;
    contactPerson?: Array<string>;
}
export namespace ProspectsSearchCondition {
    export type ListSortDirectionEnum = 0 | 1;
    export const ListSortDirectionEnum = {
        NUMBER_0: 0 as ListSortDirectionEnum,
        NUMBER_1: 1 as ListSortDirectionEnum
    };
    export type StatusEnum = '0' | '1' | '2' | '3';
    export const StatusEnum = {
        _0: '0' as StatusEnum,
        _1: '1' as StatusEnum,
        _2: '2' as StatusEnum,
        _3: '3' as StatusEnum
    };
}